// Tell Unpoly to not handle links that Bootstrap 5 manages via data-bs-toggle
// for interactive components (tabs, collapse, dropdowns).
// Excludes tooltip/popover since those don't interfere with link navigation.
const bsNoFollow = '[data-bs-toggle="tab"], [data-bs-toggle="collapse"], [data-bs-toggle="dropdown"], [data-bs-toggle="modal"], [data-bs-toggle="offcanvas"]'
up.link.config.noFollowSelectors.push(bsNoFollow)
up.link.config.noInstantSelectors.push(bsNoFollow)
up.link.config.noPreloadSelectors.push(bsNoFollow)
